import { Flex, Text } from '@conteg/ui';
import { TimeSelect } from 'components/time-select/time-select';
import { useTranslation } from 'react-i18next';
import { formatToLocalInput } from 'utils/format/format';

import { DateRangeFilter } from '../types';

interface DateRangeFilterProps {
  value: DateRangeFilter;
  onChange: (range: DateRangeFilter) => void;
}

/**
 * Common date range filter component (Created at from-to)
 * Default: last 7 days
 */
export function DateRangeFilterComponent({
  value,
  onChange,
}: DateRangeFilterProps) {
  const { t } = useTranslation();

  const handleFromChange = (from: string | null) => {
    if (from) {
      onChange({ ...value, from: new Date(from) });
    }
  };

  const handleToChange = (to: string | null) => {
    if (to) {
      onChange({ ...value, to: new Date(to) });
    }
  };

  return (
    <Flex gap="3rem" alignItems="center" flexWrap="wrap">
      <Flex gap="3rem" alignItems="center">
        <Text variant="small" content={t('Events.Filter.DateRange.From')} />
        <TimeSelect
          onChange={handleFromChange}
          value={formatToLocalInput(value.from)}
          defaultTime="00:00"
        />
      </Flex>

      <span>-</span>

      <Flex gap="3rem" alignItems="center">
        <Text variant="small" content={t('Events.Filter.DateRange.To')} />
        <TimeSelect
          onChange={handleToChange}
          value={formatToLocalInput(value.to)}
          defaultTime="23:59"
        />
      </Flex>
    </Flex>
  );
}
